function statusRegion() {
  return document.getElementById('form-status');
}

export default function announceFormStatus(kind) {
  const region = statusRegion();
  if (!region) return null;

  const message = region.dataset[kind];
  if (!message) return null;

  region.textContent = message;
  return message;
}

// The region is shared by every form on the page: only wipe the message we put
// there, never another form's announcement nor a later reCAPTCHA step.
export function clearFormStatus(kind) {
  const region = statusRegion();
  if (!region) return;
  if (region.textContent !== region.dataset[kind]) return;

  region.textContent = '';
}
